// <div>
//   This is my GitHub card available on
//   <a
//       href="https://github.com/stimulus-components/stimulus-popover"
//       className="relative"
//       data-controller="laz-popover"
//       data-action="mouseenter->laz-popover#show mouseleave->laz-popover#hide"
//   >
//     <div
//         data-laz-popover-target="content"
//         className="max-w-sm rounded shadow-lg bg-white hidden absolute left-0"
//         style="bottom: 2rem; width: max-content"
//     >
//       <div className="px-6 py-4 flex">
//         <img
//             className="rounded-full h-16 w-16"
//             src="https://avatars0.githubusercontent.com/u/8252238?s=460&u=3ba211d048536bfe01d120894eba9d3254db70d5&v=4"
//             alt=""
//         />
//
//         <div className="ml-4">
//           <div className="font-bold text-xl mb-2 text-black">Guillaume Briday</div>
//           <p className="text-gray-500 text-sm">This content is in a hidden template.</p>
//         </div>
//       </div>
//     </div>
//     <span className="text-blue-600 no-underline hover:underline">GitHub</span></a
//   >
//
//
// </div>


import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
  }


  async show(event) {
    // Temporally variable to prevent `event.currentTarget` to being null.
    this.contentTarget.classList.remove('hidden')
    // @ts-ignore
  }

  hide() {
    this.contentTarget.classList.add('hidden')
  }

}
